import { IColumn } from "@fluentui/react";
import { HelperService } from "../../../services/helper.service";
import { attributes } from "./good.type";

const helperService: HelperService = HelperService.getInstance();

export const columns: IColumn[] = [
  {
    key: helperService.makeId(10),
    name: "Ansehen",
    fieldName: "edit",
    minWidth: 60,
    maxWidth: 70,
  },
  {
    key: helperService.makeId(10),
    name: attributes.goodUnit.label,
    fieldName: attributes.goodUnit.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.goodCategory.label,
    fieldName: attributes.goodCategory.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.titleDe.label,
    fieldName: attributes.titleDe.name,
    minWidth: 70,
    maxWidth: 140,
    isRowHeader: true,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.titleRu.label,
    fieldName: attributes.titleRu.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.price.label,
    fieldName: attributes.price.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "currency",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.weight.label,
    fieldName: attributes.weight.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "weight",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.tara.label,
    fieldName: attributes.tara.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "weight",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.code.label,
    fieldName: attributes.code.name,
    minWidth: 70,
    maxWidth: 140,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
];
